module.exports = __webpack_public_path__ + "img/8mmzuantao.prt.4c00ad4f.jpg";